import { SubMenuItemType } from "@/types/menu";

export const FooterLinks = ({ items }: { items: SubMenuItemType[] }) => {
  if (!items || items.length === 0) return null;

  return (
    <div className="flex gap-x-6 pt-3">
      {items.map((item, index) => (
        <a
          key={index}
          href={item?.link || "/"}
          className="inline-flex justify-center py-1 gap-2 group/footerLinks"
        >
          {item?.hasIcon && item?.icon && (
            <span className="material-symbols-outlined w-5 h-5 text-brand inline-block !text-xl/5">
              {item?.icon}
            </span>
          )}
          {item?.title && (
            // <span className="paragraph-sm text-image-primary group-hover/footerLinks:bg-[image:var(--color-gradient-primary)] bg-[length:100%_100%] bg-left hover:bg-right transition-[background-position] duration-300 ease-in-out">
            <span className="paragraph-sm text-primary group-hover/footerLinks:text-brand duration-300 ease-in-out">
              {item?.title}
            </span>
          )}
        </a>
      ))}
    </div>
  );
};

FooterLinks.displayName = 'NavFooterLinks';